
    export var PACKAGE_VERSION = '3.0.0 (015b28e)';
    export var THEME = 'open-source-visual-refresh';
    export var ALWAYS_VISUAL_REFRESH = true;
    